
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { handleForm } from "../../redux/trainingForm";
import { useSelector, useDispatch } from 'react-redux';
import ApiProvider from '../../apiProvider/categoryApi';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";





const FooterPage = () => {

    const navigate = useNavigate();
    const disPatch = useDispatch();
    const { translateSync, currentLanguage, setCurrentLanguage } = useTranslation();

    const [categoryList, setCategoryList] = useState([])
    const staticData = [
        {
            name: "Leadership and Management",
            img: "/img/Leadership.png",
            desc: "Develop leadership, enhance teams, drive success."
        },
        {
            name: "Personal & Development Skills",
            img: "/img/Personal Growth.png",
            desc: "Unlock potential, foster growth, master essentials."
        },
        {
            name: "Sales and Marketing",
            img: "/img/Total Sales.png",
            desc: "Unlock potential, cultivate growth, master essentials."
        },
        {
            name: "Customer Service",
            img: "/img/Human Resources.png",
            desc: "Elevate skills, boost satisfaction, build lasting relationships."
        },
        {
            name: "Strategy and Strategic Planning",
            img: "/img/Goal.png",
            desc: "Master strategy, plan success, accelerate advancement."
        },
        {
            name: "Administration and Secretarial",
            img: "/img/Administration.png",
            desc: "Enhance organization, streamline tasks, support efficiency."
        }
    ];

    useEffect(() => {
        getProgramList();
    }, []);

    const getProgramList = async () => {
        const result = await ApiProvider.getCategoryList();

        if (result?.status && result.response?.data) {
            const apiData = result.response.data;

            setCategoryList(apiData);
        }
    };

    const naviGateToPage = async (id) => {
        disPatch(handleForm({ isGetList: true, id: id }));
        navigate(`/training/${id}`);
    }

    useEffect(() => {
        AOS.init({
            duration: 1000,     // animation duration
            once: false,        // allow animation every time the element is in view
            mirror: true        // animate out while scrolling past
        });
    }, []);



    return (
        <>
            {/* Footer Section */}
            <footer className="footer-section">
                <div className="container font-13">
                    <div className="row align-items-start justify-content-between">
                        {/* Column 1: Brand & About */}
                        <div className="col-md-3 footer-brand-column px-3 px-md-0 text-center text-md-start mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="100">
                            <img src="/img/logo/footer-logo-rect.png" className="footer-logo hallogo mb-2 mx-auto mx-md-0 d-block" alt="Colours Boutique Logo" style={{ width: "250px", height: "auto", objectFit: "contain" }} />
                            <p className="font-16 text-white" style={{ paddingTop: "0px", textAlign: "justify" }}>
                                Celebrating the timeless art of handwoven sarees. At Colours Boutique, we bring you the finest heritage weaves, meticulously handpicked from master artisans across India.

                            </p>
                        </div>

                        {/* Column 2: Explore */}
                        <div className="col-md-auto footer-company-column text-center text-md-start mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="100">
                            <h5 className="fw-bold">Explore</h5>
                            <ul className="list-unstyled">
                                <li><Link to="/" className="text-decoration-none footer-link">Home</Link></li>
                                <li><Link to="/about" className="text-decoration-none footer-link">Our Story</Link></li>
                                <li><Link to="/saree" className="text-decoration-none footer-link">Saree Collection</Link></li>
                                <li><Link to="/contact" className="text-decoration-none footer-link">Contact Us</Link></li>
                                <li><Link to="/faq" className="text-decoration-none footer-link">FAQ</Link></li>
                                <li><Link to="/saree-care-guide" className="text-decoration-none footer-link">Saree Care Guide</Link></li>
                            </ul>
                        </div>

                        {/* Column 3: Collections */}
                        <div className="col-md-auto footer-course-column text-center text-md-start mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="100">
                            <h5 className="fw-bold">Our Collections</h5>
                            <ul className="list-unstyled">
                                <li><Link to="/saree" className="text-decoration-none footer-link">Kanjeevaram Silk</Link></li>
                                <li><Link to="/saree" className="text-decoration-none footer-link">Heritage Uppada</Link></li>
                                <li><Link to="/saree" className="text-decoration-none footer-link">Classic Mangalagiri</Link></li>
                                <li><Link to="/saree" className="text-decoration-none footer-link">Gadwal Zari</Link></li>
                                {/* <li><Link to="/saree" className="text-decoration-none footer-link">Chettinad Cotton</Link></li> */}
                            </ul>
                        </div>

                        {/* Column 4: Customer Care */}
                        <div className="col-md-auto footer-company-column text-center text-md-start mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="100">
                            <h5 className="fw-bold">Policies</h5>
                            <ul className="list-unstyled">
                                <li><Link to="/shipping-policy" className="text-decoration-none footer-link">Shipping Policy</Link></li>
                                <li><Link to="/return-refund-policy" className="text-decoration-none footer-link">Return & Refund</Link></li>
                                <li><Link to="/cancellation-policy" className="text-decoration-none footer-link">Cancellation Policy</Link></li>
                                <li><Link to="/privacy" className="text-decoration-none footer-link">Privacy Policy</Link></li>
                                <li><Link to="/terms" className="text-decoration-none footer-link">Terms & Conditions</Link></li>
                            </ul>
                        </div>

                        {/* Column 4: Contact */}
                        <div className="col-md-auto pe-0 text-center text-md-start mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="100">
                            <h5 className="fw-bold">Get In Touch</h5>
                            <div className="d-flex flex-column gap-2 mt-3 justify-content-center justify-content-md-start">
                                {/* <a href="#" className="text-decoration-none footer-link">support@colorboutique.com</a> */}
                                <a href="#" className="text-decoration-none footer-link">coloursboutiqueadmin@gmail.com</a>
                                <a href="#" className="text-decoration-none footer-link">+91 80562 62626</a>
                                {/* <a href="#" className="text-decoration-none footer-link">+91 09876 54321</a> */}
                            </div>
                            <div className="d-flex gap-3 mt-3 justify-content-center justify-content-md-start">
                                <a href="https://www.youtube.com/@coloursboutique-p5s" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ borderColor: 'rgba(255,255,255,0.3)', textDecoration: 'none' }} title="YouTube">
                                    <i className="fa-brands fa-youtube text-white" style={{ fontSize: '14px' }}></i>
                                </a>
                                <a href="https://www.facebook.com/share/1DYSvaemWg/" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ borderColor: 'rgba(255,255,255,0.3)', textDecoration: 'none' }} title="Facebook">
                                    <i className="fa-brands fa-facebook-f text-white" style={{ fontSize: '14px' }}></i>
                                </a>
                                <a href="https://www.instagram.com/colourss.boutique?igsh=MWJtajI2ZGRvdmlqbA==" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ borderColor: 'rgba(255,255,255,0.3)', textDecoration: 'none' }} title="Instagram">
                                    <i className="fa-brands fa-instagram text-white" style={{ fontSize: '14px' }}></i>
                                </a>
                                <a href="https://x.com/colorssboutique?s=21" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ borderColor: 'rgba(255,255,255,0.3)', textDecoration: 'none' }} title="X (Twitter)">
                                    <i className="fa-brands fa-x-twitter text-white" style={{ fontSize: '14px' }}></i>
                                </a>
                                <a href="https://pin.it/40fEdEMI8" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ borderColor: 'rgba(255,255,255,0.3)', textDecoration: 'none' }} title="Pinterest">
                                    <i className="fa-brands fa-pinterest-p text-white" style={{ fontSize: '14px' }}></i>
                                </a>
                                {/* <a href="#" className="social-icon" style={{ borderColor: 'rgba(255,255,255,0.3)', textDecoration: 'none' }} title="LinkedIn">
                                    <i className="fa-brands fa-linkedin-in text-white" style={{ fontSize: '14px' }}></i>
                                </a> */}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 mb-3" >
                        <p className="mb-2 mb-md-0 font-14">&copy; {translateSync("Copyright 2026 Colours Boutique Web | All Rights Reserved")}</p>
                        <p className="mb-0 font-14">
                            Developed & Maintained by <a href="https://oceansoftwares.com" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "underline" }}>Ocean Softwares</a>
                        </p>
                    </div>
                </div>
            </footer>


            <div class="fixed-contact">

                {/* <a target="_blank" href="/calendar" title="Course Calendar" class="whatsfix calendarr">
                    <img
                        src="/img/calendar.png"
                        alt="calendar"
                        class="whatsfix calendarr"
                        data-aos="zoom-in" data-aos-delay="300"
                    />

                </a>

                <a target="_blank" href="https://wa.me/+971502550228?text=Hi" title="whatsapp" class="whatsfix">
                    <img
                        src="/img/whatsapp.svg"
                        alt="whatsapp"

                        data-aos="zoom-in" data-aos-delay="200"
                    />

                </a> */}




            </div>


        </>
    )
}
export default FooterPage;